import { render, staticRenderFns } from "./confirmSubmission.vue?vue&type=template&id=f59d20a2&"
import script from "./confirmSubmission.vue?vue&type=script&lang=js&"
export * from "./confirmSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f59d20a2')) {
      api.createRecord('f59d20a2', component.options)
    } else {
      api.reload('f59d20a2', component.options)
    }
    module.hot.accept("./confirmSubmission.vue?vue&type=template&id=f59d20a2&", function () {
      api.rerender('f59d20a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/confirmSubmission.vue"
export default component.exports